import commonService from './common';
import axios from '../axios-config';

const actions = {
  goToQuote(permalinkRequest, store, router) {
    const formData = {
      session_id: permalinkRequest.qId,
      page_name: 'Search',
      fields: null,
    };

    return axios.post('/navs/SearchContinue', formData)
      .then((response) => { // TODO: Refactor: Don't use this mixin method
        if (response.data.Navigate) {
          let newQId;
          if (response.data.NewSessionId) {
            newQId = response.data.NewSessionId;
          }
          // TODO: FIGURE OUT WHERE WE WANT TO PLUG GOOGLE ANALYTICS
          // commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'OpenQuoteAPI', 'Search');
          // if (response.data.NewSessionId) {
          //   sData.SessionId = response.data.NewSessionId;
          // }
          store.dispatch('setSessionQuote', { SessionId: newQId || permalinkRequest.qId });
          store.dispatch('setCurrentNav', response.data.Navigate);

          // TODO: Allow custom route destination to override API response's destination
          const routeName = (commonService.getRouteName(response.data.Navigate));

          router.replace(routeName); // TODO: Refactor: Don't use this mixin method
        }
      });
  },
  goToBundleQuote(permalinkRequest, store, router, type) {
    const url = `/navs/openquote/${permalinkRequest.qId}`;
    return axios.get(url)
      .then((response) => { // TODO: Refactor: Don't use this mixin method
        if (response.data.Navigate && type === 'property') {
          let newQId;
          if (response.data.NewSessionId) {
            newQId = response.data.NewSessionId;
          }
          store.dispatch('setSessionQuote', { SessionId: newQId || permalinkRequest.qId });
          store.dispatch('setCurrentNav', response.data.Navigate);

          // TODO: Allow custom route destination to override API response's destination
          const routeName = (commonService.getRouteName(response.data.Navigate));

          router.replace(routeName); // TODO: Refactor: Don't use this mixin method
        }
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/services/actions.js